import script from "./Level.vue?vue&type=script&setup=true&lang=js"
export * from "./Level.vue?vue&type=script&setup=true&lang=js"

import "./Level.vue?vue&type=style&index=0&id=ede161d4&scoped=true&lang=css"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ede161d4"]])

export default __exports__